export const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };
  
  export const formatDateTime = (dateString: string): string => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };
  
  export const getStateColor = (state: string): string => {
    switch (state) {
      case 'pending':
        return '#ff9800';
      case 'in_progress':
        return '#2196f3';
      case 'completed':
        return '#4caf50';
      case 'cancelled':
        return '#f44336';
      case 'draft':
        return '#9e9e9e';
      default:
        return '#757575';
    }
  };
  
  export const getFlowColor = (flow: string): string => {
    switch (flow) {
      case 'standard':
        return '#2196f3';
      case 'express':
        return '#ff5722';
      case 'premium':
        return '#9c27b0';
      default:
        return '#757575';
    }
  };
  
  export const truncateText = (text: string, maxLength: number): string => {
    if (!text) return '-';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };